import BaseResource from './BaseResource';
import { objectToUrlParams } from 'utils/params';

export default class FileResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  rename(name) {
    return super
      .patch({ name })
      .then((response) => response)
      .catch((error) => error.response);
  }

  duplicate(parent = '') {
    const urlParams = parent ? objectToUrlParams({ parent }) : '';
    return super
      .post({}, { url: `${this.url}/duplicate${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete() {
    return super
      .delete()
      .then((response) => response)
      .catch((error) => error.response);
  }

  download() {
    return super
      .get({
        url: `${this.url}/download?redirect=content`,
        responseType: 'blob',
        headers: {
          'cache-control': 'max-age=3600',
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  }

  export(id, params = { format: 'pdf' }) {
    const urlParams = objectToUrlParams(params);
    return super
      .post({}, { url: `/api/files/${id}/export${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  getUriSas() {
    return super
      .get({ url: `${this.url}/download?redirect=manual` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  read(id) {
    return super
      .get({ url: `/api/files/${id}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  refresh(config = {}) {
    return super
      .put({}, { url: `${this.url}/refresh`, ...config })
      .then((response) => response)
      .catch((error) => error.response);
  }

  restore(params) {
    const urlParams = objectToUrlParams(params);
    return super
      .post({}, { url: `${this.url}/restore${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  move(params) {
    const urlParams = objectToUrlParams(params);
    return super
      .put({}, { url: `${this.url}/move${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
